import { makeStyles } from '@fluentui/react-components';
import { Info20Regular } from '@fluentui/react-icons';
import { useIsViewer } from '../stores/authStore.js';

const useStyles = makeStyles({
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 24px',
    background: 'var(--opus-warning-bg, rgba(255, 196, 0, 0.12))',
    borderBottom: '1px solid var(--opus-warning-border, rgba(255, 196, 0, 0.35))',
    color: 'var(--text-primary)',
    fontSize: 'var(--fs-200)',
  },
  icon: {
    color: 'var(--opus-warning-fg, #d99100)',
    flexShrink: 0,
  },
  message: {
    lineHeight: 1.4,
  },
  strong: {
    fontWeight: 600,
  },
});

/**
 * Banner persistente para usuarios con rol `viewer`. Recuerda al usuario que
 * solo puede leer y chatear, no editar.
 *
 * Se renderiza siempre que `tenant.role === 'viewer'` — desaparece automáticamente
 * si el rol cambia (p.ej. un admin lo promueve).
 */
export function ViewerBanner() {
  const styles = useStyles();
  const isViewer = useIsViewer();
  if (!isViewer) return null;
  return (
    <div className={styles.banner} role="status">
      <Info20Regular className={styles.icon} />
      <span className={styles.message}>
        <span className={styles.strong}>Cuenta de solo consulta.</span>{' '}
        Puedes ver información y chatear con la inteligencia artificial. Para crear o editar contenido,
        pide a un administrador de tu empresa que cambie tu rol.
      </span>
    </div>
  );
}
